import { Injectable } from "@angular/core";

import { ApiService } from "./api.service";
import { managerApi } from "../../config";

@Injectable({
  providedIn: "root",
})
export class ManagerService {
  constructor(private apiService: ApiService) {}

  getAllChallengeTypes(param?: any) {
    if (param) {
      return this.apiService.get(`${managerApi.getQuizChallengeTypes}`);
    } else {
      return this.apiService.get(`${managerApi.getAllChallengeTypes}`);
    }
  }

  getChallengesByManager(params) {
    // return this.apiService.get(`${managerApi.getChallengesByManager}${params}`);
    return this.apiService.get(
      `${managerApi.getActivityChallengesByManagerId}${params}`
    );
  }

  getChallengesParticipants(params) {
    return this.apiService.get(
      `${managerApi.getChallengesParticipants}`,
      params
    );
  }

  getUsersUnderManager(managerId) {
    return this.apiService.get(
      `${managerApi.getUsersUnderManager}/${managerId}`
    );
  }

  getPrescribedEnablementsManager(params) {
    return this.apiService.get(
      `${managerApi.getPrescribedEnablementsManager}`,
      params
    );
  }

  postChallenge(challengeType, challengeData) {
    // return this.apiService.post(
    //   `${managerApi.postChallenge}${challengeType}`,
    //   challengeData
    // );
    return this.apiService.post(
      `${managerApi.postActivityChallenge}${challengeType}`,
      challengeData
    );
  }

  updateChallenge(challengeType, challengeData) {
    // return this.apiService.put(
    //   `${managerApi.postChallenge}${challengeType}`,
    //   challengeData
    // );
    return this.apiService.put(
      `${managerApi.postActivityChallenge}${challengeType}`,
      challengeData
    );
  }

  getArchitectureTypes() {
    return this.apiService.get(`${managerApi.getArchitectureTypes}`);
  }

  getEnablementCourses() {
    return this.apiService.get(`${managerApi.getEnablementCourses}`);
  }

  getTypesAndLearningMaps() {
    return this.apiService.get(`${managerApi.getTypesAndLearningMaps}`);
  }

  getTypesAndCourses() {
    return this.apiService.get(`${managerApi.getTypesAndCourses}`);
  }

  postEnablement(enablementData) {
    return this.apiService.post(`${managerApi.postEnablement}`, enablementData);
  }

  getCompanyCreditsAvailable(compID) {
    return this.apiService.get(
      `${managerApi.getCompanyCreditsAvailable}?companyId=${compID}`
    );
  }

  getCompanyTypePreferences() {
    return this.apiService.get(`${managerApi.getCompanyTypePreferences}`);
  }

  getSellerTypePreferences() {
    return this.apiService.get(`${managerApi.getSellerTypePreferences}`);
  }

  getCompanyPreferences(params) {
    return this.apiService.get(`${managerApi.companyPreferences}`, params);
  }

  getSellerPreferences(params) {
    return this.apiService.get(`${managerApi.sellerPreferences}`, params);
  }

  postCompanyPreferences(body) {
    return this.apiService.post(`${managerApi.companyPreferences}`, body);
  }

  postcompanyListPreferences(body) {
    return this.apiService.post(`${managerApi.companyListPreferences}`, body);
  }
  postSellerPreferences(body) {
    return this.apiService.post(`${managerApi.postSellerPreferences}`, body);
  }

  getUserPreferences(params) {
    return this.apiService.get(
      `${managerApi.postSellerPreferences}/${params.userId}/${params.preferenceId}`
    );
  }

  getCompanyPoints(companyId) {
    return this.apiService.get(`${managerApi.getCompanyPoints}/${companyId}`);
  }

  getCompanyUsersPoints(companyId, queryParams) {
    const url = managerApi.getCompanyUsersPoints.replace(
      "{companyId}",
      companyId
    );
    return this.apiService.get(`${url}`, queryParams);
  }

  updateSingleUserPoints(body) {
    return this.apiService.post(`${managerApi.updateSingleUserPoints}`, body);
  }

  getFiscalPeriod(params) {
    return this.apiService.get(`${managerApi.fiscalPeriod}`, params);
  }

  deleteChallenge(challengeId) {
    return this.apiService.delete(
      `${managerApi.deleteChallenge}/${challengeId}`
    );
  }

  deleteActiveChallenge(challengeId) {
    return this.apiService.delete(
      `${managerApi.deleteActiveChallenge}/${challengeId}`
    );
  }

  updateMultipleUserPoints(body) {
    return this.apiService.post(`${managerApi.updateMultipleUserPoints}`, body);
  }

  adminClaimForUser(params) {
    return this.apiService.post(
      `${managerApi.adminClaimForUser}?userId=${params.userId}&dealId=${params.dealId}`
    );
  }

  adminClaimAll(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.adminClaimall}?userId=${params.userId}`
    );
  }

  datacenterClaimall(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.datacenterClaimall}?userId=${params.userId}`
    );
  }
  nexusClaimall(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.nexusClaimall}?userId=${params.userId}`
    );
  }
  flexToClaimed(companyId, params) {
    const url = managerApi.flexToClaimed.replace("{companyId}", companyId);
    return this.apiService.get(`${url}`, params);
  }
  flexClaimall(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.flexClaimall}?userId=${params.userId}`
    );
  }
  webexToClaimed(companyId, params) {
    const url = managerApi.webexToClaimed.replace("{companyId}", companyId);
    return this.apiService.get(`${url}`, params);
  }
  webexClaimall(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.webexClaimall}?userId=${params.userId}`
    );
  }
  securityRewardToClaimed(companyId, params) {
    const url = managerApi.securityRewardToClaimed.replace(
      "{companyId}",
      companyId
    );
    return this.apiService.get(`${url}`, params);
  }
  securityRewardClaimall(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.securityRewardClaimall}?userId=${params.userId}`
    );
  }
  wirelessAcceToClaimed(companyId, params) {
    const url = managerApi.wirelessAcceToClaimedToClaimed.replace(
      "{companyId}",
      companyId
    );
    return this.apiService.get(`${url}`, params);
  }
  wirelessAcceRewardClaimall(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.wirelessAccClaimall}?userId=${params.userId}`
    );
  }
  mdsRewardToClaimed(companyId, params) {
    const url = managerApi.mdsRewardToClaimed.replace("{companyId}", companyId);
    return this.apiService.get(`${url}`, params);
  }
  mdsRewardClaimall(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.mdsRewardClaimall}?userId=${params.userId}`
    );
  }
  sdwanAccelerationToClaimed(companyId, params) {
    const url = managerApi.sdwanAccelerationToClaimed.replace(
      "{companyId}",
      companyId
    );
    return this.apiService.get(`${url}`, params);
  }
  sdwanAccelerationClaimall(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.sdwanAccelerationClaimall}?userId=${params.userId}`
    );
  }
  collaborationSprintClaimall(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.collaborationSprintClaimAll}?userId=${params.userId}`
    );
  }
  getpoSearchResult(params) {
    return this.apiService.get(
      `${managerApi.poSearchResult}?searchText=${params.searchText}&companyId=${params.companyId}`
    );
  }
  pointAccountSellerClaimedBySeller(params) {
    return this.apiService.get(
      `${managerApi.pointAccountSellerClaimedBySeller}`,
      params
    );
  }
  pointAccountClaimedByAdmin(params) {
    return this.apiService.get(
      `${managerApi.pointAccountClaimedByAdmin}`,
      params
    );
  }
  enterpriseNetworkToClaimed(companyId, params) {
    const url = managerApi.enterpriseNetworkToClaimed.replace(
      "{companyId}",
      companyId
    );
    return this.apiService.get(`${url}`, params);
  }
  enterpriseNetworkClaimall(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.enterproseNetworkClaimall}?userId=${params.userId}`
    );
  }
  designedPortfolioToClaimed(companyId, params) {
    const url = managerApi.designedPortfolioToClaimed.replace(
      "{companyId}",
      companyId
    );
    return this.apiService.get(`${url}`, params);
  }
  designedPortfolioClaimall(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.designedPortfolioClaimall}?userId=${params.userId}`
    );
  }

  cloudCallingToClaimed(companyId, params) {
    const url = managerApi.cloudCallingToClaimed.replace(
      "{companyId}",
      companyId
    );
    return this.apiService.get(`${url}`, params);
  }

  cloudCallingClaimall(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.cloudCallingClaimall}?userId=${params.userId}`
    );
  }

  getRedemptionTaxStatement(params) {
    return this.apiService.get(
      `${managerApi.pointAccountRedemptionTaxStatement}`,
      params
    );
  }

  merakiToClaimed(companyId, params) {
    const url = managerApi.merakiToClaimed.replace("{companyId}", companyId);
    return this.apiService.get(`${url}`, params);
  }

  dnaToClaimed(companyId, params) {
    const url = managerApi.dnaToClaimed.replace("{companyId}", companyId);
    return this.apiService.get(`${url}`, params);
  }

  dnaClaimall(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.dnaClaimall}?userId=${params.userId}`
    );
  }

  wanToClaimed(companyId, params) {
    const url = managerApi.wanToClaimed.replace("{companyId}", companyId);
    return this.apiService.get(`${url}`, params);
  }

  wanClaimall(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.wanClaimall}?userId=${params.userId}`
    );
  }

  saseToClaimed(companyId, params) {
    const url = managerApi.saseToClaimed.replace("{companyId}", companyId);
    return this.apiService.get(`${url}`, params);
  }

  saseClaimall(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.saseClaimall}?userId=${params.userId}`
    );
  }

  ibnToClaimed(companyId, params) {
    const url = managerApi.ibnToClaimed.replace("{companyId}", companyId);
    return this.apiService.get(`${url}`, params);
  }

  ibnClaimall(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.ibnClaimall}?userId=${params.userId}`
    );
  }

  getBudgetCapBars(params) {
    return this.apiService.post(
      `${managerApi.getBudgetCapBars}?companyId=${params.companyId}&scNumber=${params.scNumber}&userId=${params.userId}`
    );
  }
  eaToClaimed(companyId, params) {
    const url = managerApi.eaToClaimed.replace("{companyId}", companyId);
    return this.apiService.get(`${url}`, params);
  }

  eaClaimall(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.eaClaimall}?userId=${params.userId}`
    );
  }

  officeToClaimed(companyId, params) {
    const url = managerApi.officeToClaimed.replace("{companyId}", companyId);
    return this.apiService.get(`${url}`, params);
  }

  officeClaimall(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.officeClaimall}?userId=${params.userId}`
    );
  }

  iotsalesToClaimed(companyId, params) {
    const url = managerApi.iotsalesToClaimed.replace("{companyId}", companyId);
    return this.apiService.get(`${url}`, params);
  }

  iotsalesClaimall(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.iotsalesClaimall}?userId=${params.userId}`
    );
  }

  collabToClaimed(companyId, params) {
    const url = managerApi.collabToClaimed.replace("{companyId}", companyId);
    return this.apiService.get(`${url}`, params);
  }

  collabClaimall(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.collabClaimall}?userId=${params.userId}`
    );
  }

  intersightToClaimed(companyId, params) {
    const url = managerApi.intersightToClaimed.replace(
      "{companyId}",
      companyId
    );
    return this.apiService.get(`${url}`, params);
  }

  intersightClaimall(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.intersightClaimall}?userId=${params.userId}`
    );
  }

  ciscoCloudCallingToClaimed(companyId, params) {
    const url = managerApi.ciscoCloudCallingToClaimed.replace(
      "{companyId}",
      companyId
    );
    return this.apiService.get(`${url}`, params);
  }

  ciscoCloudCallingClaimall(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.ciscoCloudCallingClaimall}?userId=${params.userId}`
    );
  }

  ciscoCloudContactToClaimed(companyId, params) {
    const url = managerApi.ciscoCloudContactToClaimed.replace(
      "{companyId}",
      companyId
    );
    return this.apiService.get(`${url}`, params);
  }

  ciscoCloudContactClaimall(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.ciscoCloudContactClaimall}?userId=${params.userId}`
    );
  }

  ealToClaimed(companyId, params) {
    const url = managerApi.ealToClaimed.replace("{companyId}", companyId);
    return this.apiService.get(`${url}`, params);
  }

  ealClaimall(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.ealClaimall}?userId=${params.userId}`
    );
  }

  massScaleInfrastructureChallengeDealsToClaimed(companyId, params) {
    const url =
      managerApi.massScaleInfrastructureChallengeDealsToClaimed.replace(
        "{companyId}",
        companyId
      );
    return this.apiService.get(`${url}`, params);
  }
  fastStartChallengeDealsToClaimed(companyId, params) {
    const url = managerApi.fastStartChallengeDealsToClaimed.replace(
      "{companyId}",
      companyId
    );
    return this.apiService.get(`${url}`, params);
  }
  massScaleInfrastructureChallengeDealsClaimAll(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.massScaleInfrastructureChallengeDealsClaimAll}?userId=${params.userId}`
    );
  }
  fastStartChallengeDealsClaimAll(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.fastStartChallengeDealsClaimAll}?userId=${params.userId}`
    );
  }
  doubleUpSecurityChallengeDealsToClaimed(companyId, params) {
    const url = managerApi.doubleUpSecurityChallengeDealsToClaimed.replace(
      "{companyId}",
      companyId
    );
    return this.apiService.get(`${url}`, params);
  }
  claimAllDoubleUpSecurity(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.claimAllDoubleUpSecurity}?userId=${params.userId}`
    );
  }
  salesAccelerationChallengeDealsToClaimed(companyId, params) {
    const url = managerApi.salesAccelerationChallengeDealsToClaimed.replace(
      "{companyId}",
      companyId
    );
    return this.apiService.get(`${url}`, params);
  }
  hybridWorkSalesAccelerationChallengeDealsToClaimed(companyId, params) {
    const url =
      managerApi.hybridWorkSalesAccelerationChallengeDealsToClaimed.replace(
        "{companyId}",
        companyId
      );
    return this.apiService.get(`${url}`, params);
  }
  boostForSmallBusinessSalesChallengeDealsToClaimed(companyId, params) {
    const url =
      managerApi.boostForSmallBusinessSalesChallengeDealsToClaimed.replace(
        "{companyId}",
        companyId
      );
    return this.apiService.get(`${url}`, params);
  }
  claimAllBoostForSmallBusiness(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.claimAllDoubleUpSecurity}?userId=${params.userId}`
    );
  }
  bigMerakiSalesChallengeDealsToClaimed(companyId, params) {
    const url = managerApi.bigMerakiSalesChallengeDeals.replace(
      "{companyId}",
      companyId
    );
    return this.apiService.get(`${url}`, params);
  }
  sellTheSuiteSalesChallengeDealsToClaimed(companyId, params) {
    const url = managerApi.sellTheSuiteSalesChallengeDeals.replace(
      "{companyId}",
      companyId
    );
    return this.apiService.get(`${url}`, params);
  }
  claimAllSellTheSuite(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.claimAllSellTheSuite}?userId=${params.userId}`
    );
  }
  commercialSellerChallengeDealsToClaimed(companyId, params) {
    const url = managerApi.commercialSellerChallengeDeals.replace(
      "{companyId}",
      companyId
    );
    return this.apiService.get(`${url}`, params);
  }
  claimAllCommercialSeller(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.claimAllCommercialSeller}?userId=${params.userId}`
    );
  }
  mspSalesAccelerationChallengeDeals(companyId, params) {
    const url = managerApi.mspSalesAccelerationChallengeDeals.replace(
      "{companyId}",
      companyId
    );
    return this.apiService.get(`${url}`, params);
  }
  aacpcChalengToClaimed(companyId, params) {
    const url = managerApi.aacpcSalesChallenge.replace(
      "{companyId}",
      companyId
    );
    return this.apiService.get(`${url}`, params);
  }
  aacpcClaimall(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.claimAllAacpc}?userId=${params.userId}`
    );
  }
  webMediaSalesChallengeDealsToClaimed(companyId, params) {
    const url = managerApi.webMediaSalesChallengeDeals.replace(
      "{companyId}",
      companyId
    );
    return this.apiService.get(`${url}`, params);
  }
  claimAllWebMedia(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.claimAllWebMedia}?userId=${params.userId}`
    );
  }
  newCloudCallingChallengeDealsToClaimed(companyId, params) {
    const url = managerApi.newCloudCallingChallengeDeals.replace(
      "{companyId}",
      companyId
    );
    return this.apiService.get(`${url}`, params);
  }
  claimAllNewCloudCalling(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.claimAllNewCloudCalling}?userId=${params.userId}`
    );
  }
  getViewChallengeData(params) {
    return this.apiService.get(`${managerApi.viewChallenge}${params}`);
  }
  getCountryGroupList() {
    return this.apiService.get(`${managerApi.countryGroupList}`);
  }

  submitForApproval(params) {
    return this.apiService.post(`${managerApi.submitForApproval}${params}`);
  }
  getsalesChallengeDeals(params) {
    return this.apiService.get(
      `${managerApi.salesChallengeeligibleDeals}${params}`
    );
  }
  claimAllChallengeDeals(params) {
    return this.apiService.post(
      `${managerApi.claimAllChallengeDeals}${params}`
    );
  }
  getApprovalData(params) {
    return this.apiService.get(`${managerApi.approvalTracker}${params}`);
  }

  claimAllDeals(params) {
    return this.apiService.postCompleteResponse(
      `${managerApi.claimAll}${params}`
    );
  }
  getpointActivityData(params) {
    return this.apiService.get(`${managerApi.pointActivityLeader}${params}`);
  }
  getDistributedPointActivityData(params) {
    return this.apiService.get(
      `${managerApi.distributedPointActivity}${params}`
    );
  }

  getLeaderTicketActivityData(params) {
    return this.apiService.get(`${managerApi.ticketActivityLeader}${params}`);
  }
  getSalesActivityData(params) {
    return this.apiService.get(`${managerApi.salesActivityData}${params}`);
  }
  getSalesChallengeData(params) {
    return this.apiService.get(
      `${managerApi.salesChallengePerformence}${params}`
    );
  }
  getClaimedUnclaimedData(params) {
    return this.apiService.get(`${managerApi.claimStatusSummary}${params}`);
  }
  getStatisticsData(params) {
    return this.apiService.get(`${managerApi.statisticsData}${params}`);
  }
  createChallenge(params) {
    return this.apiService.get(`${managerApi.statisticsData}${params}`);
  }
  createBookingChallenge(bookingChallengeData) {
    return this.apiService.postCompleteResponse(
      `${managerApi.createBookingChallenge}`,
      bookingChallengeData
    );
  }
  createTrainingChallenge(trainingChallengeData) {
    return this.apiService.postCompleteResponse(
      `${managerApi.createTrainingChallenge}`,
      trainingChallengeData
    );
  }
  createArchitectureChallenge(architectureChallengeData) {
    return this.apiService.postCompleteResponse(
      `${managerApi.createArchitectureChallenge}`,
      architectureChallengeData
    );
  }
  getBookingChallengeById(challengeId) {
    return this.apiService.getCompleteResponse(
      `${managerApi.getBookingChallengeById}${challengeId}`
    );
  }
  getTrainingChallengeById(challengeId) {
    return this.apiService.getCompleteResponse(
      `${managerApi.getTrainingChallengeById}${challengeId}`
    );
  }
  getArchitectureChallengeById(challengeId) {
    return this.apiService.getCompleteResponse(
      `${managerApi.getArchitectureChallengeById}${challengeId}`
    );
  }
  updateBookingChallenge(bookingChallengeData) {
    return this.apiService.put(
      `${managerApi.createBookingChallenge}`,
      bookingChallengeData
    );
  }
  updateTrainingChallenge(trainingChallengeData) {
    return this.apiService.put(
      `${managerApi.createTrainingChallenge}`,
      trainingChallengeData
    );
  }
  updateArchitectureChallenge(architectureChallengeData) {
    return this.apiService.put(
      `${managerApi.createArchitectureChallenge}`,
      architectureChallengeData
    );
  }

  deleteActivityChallenge(challengeId) {
    return this.apiService.delete(
      `${managerApi.deleteActivityChallenge}/${challengeId}`
    );
  }
  updateActivityChallengeStatus(params) {
    return this.apiService.post(`${managerApi.updateStatus}/${params}`);
  }

  getFiscalOptions() {
    return this.apiService.get(`${managerApi.fiscalOptions}`);
  }
  getParticipantsChallengeById(challengeId) {
    return this.apiService.getCompleteResponse(
      `${managerApi.getParticipantsChallenge}${challengeId}`
    );
  }
  createParticipantsChallenge(data) {
    return this.apiService.postCompleteResponse(
      `${managerApi.createParticipantsChallenge}`,
      data
    );
  }
  updateParticipantsData(params) {
    return this.apiService.put(
      `${managerApi.createParticipantsChallenge}`,
      params
    );
  }
  getCountryListByRegion(regionList) {
    return this.apiService.get(
      `${managerApi.getCountryListByRegion}?regions=${regionList}`
    );
  }
  createNewLeaderboardChallenge(payload) {
    if (payload.id) {
      return this.apiService.put(
        `${managerApi.createLeaderboardChallenge}`,
        payload
      );
    } else {
      return this.apiService.post(
        `${managerApi.createLeaderboardChallenge}`,
        payload
      );
    }
  }
  getLeaderBoardChallengesListCiscoAdmin(params) {
    return this.apiService.get(
      `${managerApi.getLeaderBoardChallengesListCiscoAdmin}${params}`
    );
  }
  getLeaderBoardChallengesListLeader(params) {
    return this.apiService.get(
      `${managerApi.getLeaderBoardChallengesListLeader}`,
      params
    );
  }
  getLeaderBoardChallengesListSeller(params) {
    return this.apiService.get(
      `${managerApi.getLeaderBoardChallengesListSeller}`,
      params
    );
  }
  getLeaderboardChallengeById(id) {
    return this.apiService.get(
      `${managerApi.getLeaderBoardChallengeById}${id}`
    );
  }
  getActivityData(startDate, endDate, regions, participantType) {
    return this.apiService.get(
      `${managerApi.activityChallenge}?startDate=${startDate}&endDate=${endDate}&regions=${regions}&participantType=${participantType}`
    );
  }
  deleteLeaderboardChallengeById(challengeId) {
    return this.apiService.delete(
      `${managerApi.deleteLeaderboardChallengeById}/${challengeId}`
    );
  }
  updateLeaderboardChallengeStatus(params) {
    return this.apiService.post(
      `${managerApi.updateLeaderboardChallengeStatus}?id=${params.id}&status=${params.status}`
    );
  }
  createProductBookingChallenge(payload) {
    if (payload.id) {
      return this.apiService.put(
        `${managerApi.createProductsBooking}`,
        payload
      );
    } else {
      return this.apiService.post(
        `${managerApi.createProductsBooking}`,
        payload
      );
    }
  }
  getProductBookingById(id) {
    return this.apiService.get(`${managerApi.getProductBookingById}${id}`);
  }
  getProductBookingProgress(id) {
    return this.apiService.get(`${managerApi.getProductBookingProgress}${id}`);
  }
  getCustomChallenges(params) {
    return this.apiService.get(`${managerApi.getCustomChallenges}`, params);
  }
  getActivityChallengeById(challengeName, id) {
    // return this.apiService.get(`${managerApi.postChallenge}${challengeName}${'/'+id}`)
    return this.apiService.get(
      `${managerApi.postActivityChallenge}${challengeName}${"/" + id}`
    );
  }
  getAdminActivityChallengeById(challengeName, id) {
    return this.apiService.get(
      `${managerApi.getAdminActivityChallenge}${challengeName}${"/" + id}`
    );
  }
  cloneActivityChallengeById(challengeName, id) {
    return this.apiService.get(
      `${managerApi.cloneActivityChallenge}${challengeName}${"/" + id}`
    );
  }
  cloneLeaderChallengeById(id) {
    return this.apiService.get(
      `${managerApi.cloneLeaderboardChallengeById}${id}`
    );
  }
  getActivityFiscalOptions() {
    return this.apiService.get(`${managerApi.activityFiscalOptions}`);
  }
  checkOverrideFromAutoToManual(pathParams) {
    return this.apiService.get(
      `${managerApi.checkOverrideFromAutoToManual}${pathParams}`
    );
  }
  acSubmitProofs(id, fileData, params) {
    return this.apiService.postForFileProgress(
      `${managerApi.submitProof}${"/" + id}${params}`,
      fileData
    );
  }
  getProofOfDocumentsList(id) {
    return this.apiService.get(
      `${managerApi.proofOfDocuments}?userChallengeId=${id}`
    );
  }
  getDocTypeList() {
    return this.apiService.get(`${managerApi.docTypesList}`);
  }
  getCommentsById(chatData) {
    if (chatData.fileData.name == "chatModal") {
      return this.apiService.get(
        `${managerApi.getCommentsByFileId}?userChallengeId=${chatData.fileData.approverData.userChallengeId}&fileId=${chatData.fileData.approverData.fileId}`
      );
    } else {
      return this.apiService.get(
        `${managerApi.getCommentsByFileId}?userChallengeId=${chatData.userChallengeId}&fileId=${chatData.fileData.id}`
      );
    }
  }
  addCommentsById(chatData) {
    return this.apiService.post(`${managerApi.addCommentsByFileId}${chatData}`);
  }
  getActiveLeaderboardChallenges(startDate, endDate, regions, participantType) {
    return this.apiService.get(
      `${managerApi.activeLeaderboardChallenge}?startDate=${startDate}&endDate=${endDate}&regions=${regions}&participantType=${participantType}`
    );
  }
  getLeaderboardChgProgress(id) {
    return this.apiService.get(
      `${managerApi.getLeaderboardChallengeProgress}${id}`
    );
  }
  getAcPossibleValues() {
    return this.apiService.get(`${managerApi.acPossibleValues}`);
  }
  getEnablementCourseTypes() {
    return this.apiService.get(`${managerApi.enablementCourseTypes}`);
  }
  addRebateCoordinators(req) {
    return this.apiService.post(`${managerApi.rebatecoordinators}`, req);
  }
  getRebateCoordinators(req) {
    return this.apiService.get(`${managerApi.getRebateCoordinators}${req}`);
  }
  generateFileTansCDocuments(req) {
    return this.apiService.get(
      `${managerApi.generateTandConditionsFile}${req}`
    );
  }
  generateEligProductsDocumentationAsDownloadable(req) {
    return this.apiService.get(
      `${managerApi.generateEligProductsDocumentationAsDownloadable}${req}`
    );
  }
  getQuarterLevelBudgetcapData(req:any){
    return this.apiService.get(`${managerApi.getQuaterLevelBudget}${req}`);
  }
  saveQuarterLevelBudget(payload: any){
    return this.apiService.post(managerApi.saveQuarterLevelBudget, payload);
  }
  updateBudgetcapData(id: any, payload: any){
    return this.apiService.put(
      `${managerApi.updateBudgetcapData}/${id}`, payload
    );
  }
}
